/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FinancialRiskToleranceValue {
  LOWER_RISK_HIGHER_PREMIUM = 'LOWER_RISK_HIGHER_PREMIUM',
  HIGHER_RISK_LOWER_PREMIUM = 'HIGHER_RISK_LOWER_PREMIUM',
  IN_BETWEEN = 'IN_BETWEEN',
}
